import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Lazy load components for code splitting
const Register = React.lazy(() => import("../pages/Register/Register"));
const HomePage = React.lazy(() => import("../pages/Home/HomePage"));
const SendRequest = React.lazy(() => import("../pages/Ads/SendRequest"));
const KarimPage = React.lazy(() => import("../pages/KarimPage/KarimPage"));
const AboutPage = React.lazy(() => import("../pages/About/AboutPage"));
const IndexPage = React.lazy(() => import("../pages/Index/IndexPage"));
const TheApp = React.lazy(() => import("../pages/TheApp/TheApp"));
const FAQPage = React.lazy(() => import("../pages/FAQ/FAQPage"));
const LegalDisclosure = React.lazy(() => import("../pages/LegalDisclosure/LegalDisclosure"));
const TermsCondition = React.lazy(() => import("../pages/TermsConditions/TermsConditions"));
const PrivacyPolicy = React.lazy(() => import("../pages/PrivacyPolicy/PrivacyPolicy"));
const Payment = React.lazy(() => import("../pages/Register/Payment"));
const BlogPage = React.lazy(() => import("../pages/Blog/BlogPage"));
const BlogDetailsPage = React.lazy(() => import("../pages/Blog/BlogDetailsPage"));

const Routepage = () => {
  return (
    <>
      <HelmetProvider>
        <Suspense fallback={<div style={{ minHeight: '100vh', background: '#fff' }}></div>}>
          <Routes>
            <Route path="/" element={<IndexPage />} />
            <Route path="/becomeapartner" element={<HomePage />} />
            <Route path="/register" element={<Register />} />
            <Route path="/ads" element={<SendRequest />} />
            <Route path="/karim" element={<KarimPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/legal-disclosure" element={<LegalDisclosure />} />
            <Route path="/terms-conditions" element={<TermsCondition />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/p" element={<Payment />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:id" element={<BlogDetailsPage />} />
          </Routes>
        </Suspense>
      </HelmetProvider>
    </>
  );
};

export default Routepage;
